import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useAetMcqStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    padding: 16,
    borderRadius: 16,
    background: '#FEFEFE'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0
  },
  assignmentName: {
    overflow: 'hidden',
    color: mixins.zambezi,
    fontFeatureSettings: '\'liga\' off',
    textOverflow: 'ellipsis',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight400,
    lineHeight: mixins.lineHeight20
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  questionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 20
  },
  chapterHeader: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize20,
    lineHeight: '28px',
    letterSpacing: 0,
    color: '#171717',
    verticalAlign: 'middle',
    marginBottom: 0
  },
  chapterSubHeader: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: '16px',
    letterSpacing: 0,
    color: '#5D5D5D',
    verticalAlign: 'middle'
  },
  question: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: '20px',
    letterSpacing: 0,
    color: '#5D5D5D',
    verticalAlign: 'middle'
  },
  attemptsCount: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: '16px',
    color: '#171717'
  },
  flaggedChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 8px',
    background: '#E0E0E0',
    color: '#171717',
    borderRadius: 6,
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontSize: 12,
    lineHeight: '16px'
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden'
  },
  optionRow: {
    display: 'grid',
    gridTemplateColumns: '24px 1fr auto',
    alignItems: 'center',
    columnGap: 8,
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    background: '#FFFFFF',
    boxSizing: 'border-box'
  },
  optionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: 1,
    minWidth: 0,
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflow: 'hidden'
  },
  optionLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: 14,
    lineHeight: '22px',
    color: '#1F2430',
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'initial'
  },
  correctLabel: {
    color: '#006632'
  },
  wrongLabel: {
    color: '#B20900'
  },
  optionSubLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: '20px'
  },
  correctSubLabel: {
    color: '#006632'
  },
  wrongSubLabel: {
    color: '#B20900'
  },
  correct: {
    border: '1px solid #00B057',
    background: '#EBF9F0'
  },
  wrong: {
    border: '1px solid #FF362A',
    background: '#FFE7E5'
  },
  optionIcon: {
    justifySelf: 'end'
  },
  statusIcon: {
    width: 18,
    height: 18,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  statusIconCorrect: {
    backgroundColor: '#006632'
  },
  statusIconWrong: {
    backgroundColor: '#B20900'
  },
  optionPrefix: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: 14,
    lineHeight: '24px',
    letterSpacing: 0,
    textAlign: 'center',
    border: '1px solid #D0D5DD',
    color: '#171717',
    background: '#E8E6F3',
    padding: 0,
    opacity: 1,
    boxSizing: 'border-box'
  },
  prefixCorrect: {
    borderColor: '#00B057',
    color: '#006632',
    background: '#C4EED2'
  },
  prefixWrong: {
    borderColor: '#FF362A',
    color: '#B20900',
    background: '#FFCFCC'
  },
  footer: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px',
    marginTop: 16,
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    width: '16px',
    height: '16px'
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 16
  },
  footerWithOnlyChild: {
    display: 'contents'
  },
  reviewAssignmentLink: {
    fontFamily: mixins.fontFamilyPlusSans,
    color: mixins.navyColor,
    fontSize: mixins.fontSize14,
    fontWeight: mixins.fontWeight500,
    lineHeight: '22px',
    marginTop: 16,
    cursor: 'pointer',
    alignItems: 'center',

    '&:hover': {
      textDecoration: 'underline'
    }
  },
  footerLeftCluster: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    minWidth: 0,
    marginTop: 16,

    '& $reviewAssignmentLink': {
      marginTop: 0
    }
  },
  redirectIcon: {
    marginBottom: 1
  },
  courseMenuRoot: {
    '&&': {
      padding: '8px !important'
    }
  },
  menuItem: {
    padding: 8,
    minWidth: 150,
    display: 'flex',
    gap: '8px',

    '& p': {
      color: mixins.timeIconColor,
      fontFeatureSettings: '\'liga\' off',
      fontFamily: mixins.fontFamilyPlusSans,
      fontSize: mixins.fontSize14,
      fontStyle: 'normal',
      fontWeight: mixins.fontWeight400,
      lineHeight: '22px'
    },

    '&:hover': {
      backgroundColor: mixins.quaternary
    }
  },
  threeDotMenuIcon: {
    width: 20,
    height: 20
  },
  statusTagMenuContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0
  },
  askAiCtaIcon: {
    width: 20,
    height: 20,
    flexShrink: 0
  },
  askAiCtaLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    fontWeight: mixins.fontWeight600,
    lineHeight: '22px',
    letterSpacing: 0,
    color: mixins.chalkWhiteFont,
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  askAiCtaHeaderPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 999,
    border: '1px solid rgba(107, 75, 196, 0.28)',
    boxShadow: '0 1px 2px rgba(23, 23, 23, 0.06)',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease',
    background: 'linear-gradient(135deg, #512EAB 0%, #6F4BC4 100%)',
    minWidth: '180px',
    justifyContent: 'center',

    '&:hover': {
      boxShadow: '0 2px 8px rgba(107, 75, 196, 0.18)',
      borderColor: 'rgba(107, 75, 196, 0.45)'
    },
    '&:focus-visible': {
      outline: '2px solid #6B4BC4',
      outlineOffset: 2
    },
    '& svg': {
      width: 32,
      height: 32
    }
  },
  questionStem: {
    display: 'flex',
    width: '100%'
  },
  questionNumberWrapper: {
    display: 'flex',
    marginRight: 4
  },
  chapterWrapper: {
    width: '100%'
  },
  questionTitle: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize20,
    fontWeight: mixins.fontWeight500,
    lineHeight: '28px',
    letterSpacing: '-0.4px'
  },
  primaryCol1: {
    padding: '0px 4px'
  },
  headingWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  heading: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight400,
    lineHeight: '20px'
  }
});

export default useAetMcqStyles;
